(function () {
  function getConnection() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  }

  function shouldSkipVideo() {
    const connection = getConnection();

    if (connection && connection.saveData) return true;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return true;
    }

    return false;
  }

  function initVideo(video) {
    if (!video || video.dataset.cbVideoReady === 'true') return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const src = isMobile
      ? video.dataset.mobileSrc || video.dataset.desktopSrc
      : video.dataset.desktopSrc || video.dataset.mobileSrc;

    if (!src) return;

    video.dataset.cbVideoReady = 'true';
    video.src = src;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.preload = 'metadata';

    video.addEventListener(
      'loadeddata',
      function () {
        video.classList.add('is-ready');
      },
      { once: true }
    );

    video.load();

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    video.pause();
  }

  function boot() {
    const videos = Array.from(
      document.querySelectorAll('.cb-making-process video[data-cb-lazy-video]')
    );

    if (!videos.length || shouldSkipVideo()) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(initVideo);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;

          if (entry.isIntersecting) {
            initVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      {
        root: null,
        rootMargin: '180px 0px',
        threshold: 0.18
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();